import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";

const LOGO_URL = "https://customer-assets-wrfwihn1.emergentagent.net/job_78adfbdd-52b0-4e44-92bc-80f4766e6ce9/artifacts/ls9rp1yc_ChatGPT%20Image%20Sep%203%2C%202026%2C%2009_24_57%20AM.png";

export default function Footer() {
  const { t } = useI18n();
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <footer className="bg-[color:var(--wv-obsidian)] text-slate-300 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-14">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Link to="/" onClick={scrollTop} className="inline-flex items-center gap-2" data-testid="footer-logo-home">
              <div className="bg-white rounded-xl px-3 py-2">
                <img src={LOGO_URL} alt="Woon Verder" className="h-10 w-auto" />
              </div>
            </Link>
            <p className="mt-5 text-lg font-display font-semibold text-white max-w-md">
              {t("footer.tagline")}
            </p>
            <p className="mt-2 text-sm text-slate-400 max-w-md">
              {t("footer.subtag")}
            </p>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-3">{t("footer.section_platform")}</p>
            <ul className="space-y-2 text-sm">
              <li><Link to="/woningen" className="hover:text-white" data-testid="footer-link-properties">{t("nav.properties")}</Link></li>
              <li><Link to="/woning-verkopen" className="hover:text-white" data-testid="footer-link-sellers">{t("nav.sellers")}</Link></li>
              <li><Link to="/woning-zoeken" className="hover:text-white" data-testid="footer-link-search">{t("footer.link_search_profile")}</Link></li>
              <li><Link to="/zoekservice" className="hover:text-white" data-testid="footer-link-zoekservice">{t("footer.link_zoekservice")}</Link></li>
              <li><Link to="/mijn-woon-verder" className="hover:text-white" data-testid="footer-link-mine">{t("footer.link_mine")}</Link></li>
              <li><Link to="/hoe-het-werkt" className="hover:text-white" data-testid="footer-link-how">{t("nav.how")}</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-3">{t("footer.section_company")}</p>
            <ul className="space-y-2 text-sm">
              <li><Link to="/over-ons" className="hover:text-white">{t("nav.about")}</Link></li>
              <li><Link to="/werk-bij-ons" className="hover:text-white" data-testid="footer-link-careers">{t("nav.careers")}</Link></li>
              <li><Link to="/contact" className="hover:text-white">{t("nav.contact")}</Link></li>
              <li><Link to="/privacy" className="hover:text-white" data-testid="footer-link-privacy">{t("footer.link_privacy")}</Link></li>
              <li><Link to="/algemene-voorwaarden" className="hover:text-white" data-testid="footer-link-terms">{t("footer.link_terms")}</Link></li>
              <li><Link to="/klachten" className="hover:text-white" data-testid="footer-link-complaints">{t("footer.link_complaints")}</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-white/10 grid gap-3 sm:grid-cols-2 text-xs text-slate-400">
          <div>
            <p className="font-semibold text-slate-200">BK International B.V.</p>
            <p>KvK <span className="font-mono">92949916</span> · BTW <span className="font-mono">NL866227118B01</span></p>
            <p className="mt-1">Email: <a href="mailto:info@woonverder.eu" className="hover:text-white">info@woonverder.eu</a></p>
          </div>
          <div className="sm:text-right">
            <p>© {new Date().getFullYear()} Woon Verder — {t("footer.rights")}</p>
            <p className="mt-1">{t("footer.launch_line")}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
